import React, { useState } from "react";

import { leadViews } from "../../common/views";

import { NavLink } from "react-router-dom";
import {
  CalendarOutlined,
  ClusterOutlined,
  EyeOutlined,
  LayoutOutlined,
  SolutionOutlined,
  MailOutlined,
  CloudUploadOutlined,
  LineChartOutlined,
  GlobalOutlined,
  CodeOutlined,
  DollarOutlined,
  FileDoneOutlined,
  FileTextOutlined,
  MessageOutlined,
} from "@ant-design/icons";

import { DEFAULT_PAGE_SIZE } from "../../common/navs";

import { Menu } from "antd";

import styles from "./Nav.module.scss";
import {
  getStoredPageSettings,
  updateStoredPageSettings,
} from "../../utils/settings";

const DEFAULT_OPEN_SECTION_KEYS = ["g1", "g2", "g4", "g5"];
const NAV_STORAGE_KEY = "nav.acquisitions";

const Acquisitions = (props) => {
  const { collapsed, navSelectedKeys } = props;

  const [openSections, setOpenSections] = useState(() => {
    const settings = getStoredPageSettings(NAV_STORAGE_KEY);
    return settings.openSections || DEFAULT_OPEN_SECTION_KEYS;
  });

  const handleOpenChange = (newSections) => {
    if (collapsed) return;
    setOpenSections(newSections);
    updateStoredPageSettings(NAV_STORAGE_KEY, { openSections: newSections });
  };

  const getMenuItems = () => {
    return [
      // Interests Group
      {
        key: "g1",
        label: "Interests",
        children: [
          {
            key: "texas_tax_roll_files",
            label: (
              <NavLink
                to={`/texas-tax-roll-files?limit=${DEFAULT_PAGE_SIZE}&page=1`}
              >
                <FileTextOutlined />
                <span>Tax roll files</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "permit_plats",
            label: (
              <NavLink to={`/permit-plats?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <FileDoneOutlined />
                <span>Permit plats</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "permits",
            label: (
              <NavLink to={`/permits?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <FileDoneOutlined />
                <span>Permits</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "units",
            label: (
              <NavLink to={`/units?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <LayoutOutlined />
                <span>Units</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "field_units",
            label: (
              <NavLink to={`/field-units?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <LayoutOutlined />
                <span>Field units</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "owners",
            label: (
              <NavLink to="/owners?limit=50&page=1">
                <ClusterOutlined />
                <span>Owners</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "owner_name_addresses",
            label: (
              <NavLink
                to={`/owner-name-addresses?limit=${DEFAULT_PAGE_SIZE}&page=1`}
              >
                <SolutionOutlined />
                <span>Name addresses</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "validation_clusters",
            label: (
              <NavLink to="/owner-name-address-validation-clusters">
                <SolutionOutlined />
                <span>Validation clusters</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
        ],
      },
      // Acquisitions Group
      {
        key: "g2",
        label: "Acquisitions",
        children: [
          {
            key: "offers",
            label: (
              <NavLink to={`/offers?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <DollarOutlined />
                <span>Offers</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "leads",
            label: (
              <NavLink
                to={`/leads?view=${leadViews.tax_roll}&limit=${DEFAULT_PAGE_SIZE}&page=1`}
              >
                <EyeOutlined />
                <span>Leads</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "evaluations",
            label: (
              <NavLink to={`/evaluations?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <EyeOutlined />
                <span>Evaluations</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "deal_reviews",
            label: (
              <NavLink to={`/deal-reviews?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <EyeOutlined />
                <span>Deal reviews</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "titles",
            label: (
              <NavLink to={`/titles?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <FileDoneOutlined />
                <span>Titles</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
        ],
      },
      // Ops Group
      {
        key: "g3",
        label: "Ops",
        children: [
          {
            key: "activities",
            label: (
              <NavLink
                to={`/activities?limit=${DEFAULT_PAGE_SIZE}&page=1&filters=status%3Dtodo`}
              >
                <CalendarOutlined />
                <span>Activities</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "idi_bulk_searches",
            label: (
              <NavLink
                to={`/idi-bulk-searches?limit=${DEFAULT_PAGE_SIZE}&page=1`}
              >
                <CodeOutlined />
                <span>IDI bulks</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "usps_bulk_searches",
            label: (
              <NavLink
                to={`/usps-bulk-searches?limit=${DEFAULT_PAGE_SIZE}&page=1`}
              >
                <CodeOutlined />
                <span>USPS bulks</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "whitepages_bulk_searches",
            label: (
              <NavLink
                to={`/whitepages-bulk-searches?limit=${DEFAULT_PAGE_SIZE}&page=1`}
              >
                <CodeOutlined />
                <span>Whitepages bulks</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "mail_exports",
            label: (
              <NavLink to={`/mail-exports?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <MailOutlined />
                <span>Mail exports</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "mail_queue",
            label: (
              <NavLink to={`/mail-queue`}>
                <CloudUploadOutlined />
                <span>Mail queue</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "pipedrive_uploads",
            label: (
              <NavLink
                to={`/pipedrive-uploads?limit=${DEFAULT_PAGE_SIZE}&page=1`}
              >
                <CloudUploadOutlined />
                <span>Pipedrive uploads</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
        ],
      },
      // Communications Group
      {
        key: "s4",
        label: "Communications",
        children: [
          {
            key: "calls",
            label: (
              <NavLink to={`/calls?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <CodeOutlined />
                <span>Calls</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "conversations",
            label: (
              <NavLink
                to={`/conversations?limit=${DEFAULT_PAGE_SIZE}&page=1&sort=-last_message_at&filters=archived%3Dfalse`}
              >
                <MessageOutlined />
                <span>Conversations</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "caller_id_reputations",
            label: (
              <NavLink
                to={`/caller-id-reputations?limit=${DEFAULT_PAGE_SIZE}&page=1`}
              >
                <CodeOutlined />
                <span>Caller IDs</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "phone_validation",
            label: (
              <NavLink to="/phones">
                <CodeOutlined />
                <span>Validation</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
        ],
      },
      // Contact data Group
      {
        key: "s5",
        label: "Contact data",
        children: [
          {
            key: "idi_searches",
            label: (
              <NavLink to={`/idi-searches?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <CodeOutlined />
                <span>IDI searchs</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "idi_persons",
            label: (
              <NavLink to={`/idi-persons?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <CodeOutlined />
                <span>IDI people</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "endato_searches",
            label: (
              <NavLink
                to={`/endato-searches?limit=${DEFAULT_PAGE_SIZE}&page=1`}
              >
                <CodeOutlined />
                <span>Endato searches</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "endato_persons",
            label: (
              <NavLink to={`/endato-persons?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <CodeOutlined />
                <span>Endato people</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "whitepages_searches",
            label: (
              <NavLink
                to={`/whitepages-searches?limit=${DEFAULT_PAGE_SIZE}&page=1`}
              >
                <CodeOutlined />
                <span>Whitepages searches</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "whitepages_persons",
            label: (
              <NavLink
                to={`/whitepages-persons?limit=${DEFAULT_PAGE_SIZE}&page=1`}
              >
                <CodeOutlined />
                <span>Whitepages people</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "usps_searches",
            label: (
              <NavLink to={`/usps-searches?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <CodeOutlined />
                <span>USPS searches</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "usps_addresses",
            label: (
              <NavLink to={`/usps-addresses?limit=${DEFAULT_PAGE_SIZE}&page=1`}>
                <CodeOutlined />
                <span>USPS addresses</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
        ],
      },
      // Reports Group
      {
        key: "g4",
        label: "Reports",
        children: [
          {
            key: "acquisitionsReportsMain",
            label: (
              <NavLink to="/acquisitions/reports/main">
                <LineChartOutlined />
                <span>Main</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "mailerChecks",
            label: (
              <NavLink to="/acquisitions/mailer-checks">
                <LineChartOutlined />
                <span>Mailer</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
        ],
      },
      // Maps Group
      {
        key: "g5",
        label: "Maps",
        children: [
          {
            key: "map",
            label: (
              <NavLink to="/map">
                <GlobalOutlined />
                <span>Main</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "area_of_interests",
            label: (
              <NavLink to="/area-of-interests?limit=50&page=1">
                <GlobalOutlined />
                <span>AOIs</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
        ],
      },
    ];
  };

  return (
    <Menu
      theme="light"
      mode="inline"
      className={collapsed ? null : styles.siderMenu}
      selectedKeys={navSelectedKeys}
      openKeys={collapsed ? [] : openSections}
      onOpenChange={handleOpenChange}
      items={getMenuItems()}
    />
  );
};

export default Acquisitions;
